import React, { useState } from 'react';

// Material UI

// Import our store

// API

// Types
interface Props {

}

const ErrorPage = ({}: Props) => {
  return (
    <h1>Error Page</h1>
  );
};

export default ErrorPage;